import { productListFilterAccordionSectionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import { StyleProps as CheckboxStyleProps } from "@insite/mobius/Checkbox/Checkbox";
import { css } from "styled-components";

productListFilterAccordionSectionStyles.accordionSection = {
    panelProps: {
        css: css`
            overflow-y: auto;
            overflow-x: hidden;
            max-height: 350px;
            background: #f4f3f1;
            border: none;
        `,
    },
};

productListFilterAccordionSectionStyles.checkBoxSelected = {
    css: css<CheckboxStyleProps>`
        align-items: flex-start;
        span[role="checkbox"] {
            background-color: #ffffff !important;
            ${({ _sizeVariant }) =>
                _sizeVariant === "small"
                    ? css`
                          margin-top: 5px;
                      `
                    : css`
                          margin-top: 4px; ;
                      `}
        }
    `,
    typographyProps: {
        css: css`
            word-break: break-all;
        `,
        weight: "bold",
    },
};
